import type { UseMutationProps } from '@ztechapps/common.hook'
import { useActionMutation } from '@ztechapps/common.hook'
import type { MarkOrderNotReceivableArgs, Order } from '@ztechapps/common.contract'
import { ORDER_MARK_NOT_RECEIVABLE_MUTATION } from './graphql'

/**
 * Marks an order "Not Receivable" (value=true, requires a reason) or reverts it
 * (value=false, no reason). Wraps the `orderMarkNotReceivable` action mutation.
 * The reason is recorded server-side in the order activity log; the user is
 * injected server-side from the request context.
 */
export const useMarkOrderNotReceivable = ({ query, ...props } = {} as UseMutationProps) => {
  return useActionMutation<Order, MarkOrderNotReceivableArgs>({
    query: query ?? ORDER_MARK_NOT_RECEIVABLE_MUTATION,
    ...props,
  })
}
